import React from "react";
import Icon, { type IconProps } from "./Icon";

/**
 * AlertTriangle icon — vendored from Lucide.
 * Source: https://lucide.dev/icons/alert-triangle (MIT). Copied 2026-05-16.
 *
 * Phase 2c: replaces Banner's `⚠` Unicode for tone="warning".
 */
export default function AlertTriangle(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </Icon>
  );
}
